import _ from 'lodash';
import { SITE_ASSET_FOLDERS } from '@/constants';

const importSite = {
  methods: {
    openImport() {
      this.$refs.importInput.click();
    },
    importSite(e) {
      this.$validator.validateAll().then(async (result) => {
        // run only if file types and dimensions are correct
        if (result) {
          let newFile = [...e.target.files];
          if (newFile.length > 0) {
            newFile = newFile[0];
            const fileread = new FileReader();
            fileread.onload = (e) => {
              const data = e.target.result;
              const site = JSON.parse(data);
              this.mergeSite(site);
            };
            fileread.readAsText(newFile);
          }
          // reset value to null so we can get the "change" event to run
          // in any case. Even when the user selects the same file
          e.target.value = null;
        }
      });
    },
    async mergeSite(newSite) {
      const notif = {
        id: this.guid(),
        type: 'success',
        message: 'Successfully imported site!',
      };
      try {
        this.loading = true;
        const currentSite = _.cloneDeep(this.currentSite);
        newSite.planId = currentSite.planId;
        newSite.planPrice = currentSite.planPrice;
        newSite.tier = currentSite.tier;
        const limits = this._checkLimits(newSite);
        _.forOwn(limits, (limit, key) => {
          if (limit.reached) {
            throw new Error(`'Cannot proceed. ${key} limit reached'`);
          }
        });
        const newBuild = await this._SEND([{
          name: 'importSiteFromFile',
          payload: {
            chosenPlate: newSite,
            assetFolders: SITE_ASSET_FOLDERS,
            site: currentSite,
            createdDate: new Date().toISOString(),
          },
        }]);
        this.$log.debug('successfully imported new site: ', newBuild);
        await this.$store.dispatch('setCurrentSite', newBuild);
      } catch (e) {
        notif.type = 'error';
        notif.message = e.message || e;
        this.$log.error(e.message || e);
      } finally {
        this.loading = false;
        setTimeout(() => {
          this.$store.dispatch('addNotification', notif);
        }, 1000);
      }
    },
  },
};

export { importSite };



// WEBPACK FOOTER //
// ./src/storm/mixins/import-site.js